import React from 'react';
import { useUser } from 'context/UserContext';
import { OrderHistoryWidgetView as View } from './View';
export var OrderHistoryWidgetContainer = function () {
    var _a, _b, _c;
    var account = useUser().account;
    return (React.createElement(View, { accountId: account === null || account === void 0 ? void 0 : account.id, loading: false, totalOrders: (_b = (_a = account === null || account === void 0 ? void 0 : account.orders) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, orders: (_c = account === null || account === void 0 ? void 0 : account.orders) !== null && _c !== void 0 ? _c : [] }));
};
